module.exports = __webpack_public_path__ + "images/places/training_701-4ff77615e68a8df0c099032ee9b687d7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_701.jpg
 ** module id = 326
 ** module chunks = 0
 **/